<template>
  <div class="account-filter border-bg">
    <el-select
      v-model="permissionStatus"
      filterable
      placeholder="授权状态"
      class="account-select"
      style="width: 160px"
      @change="searchData"
    >
      <el-option label="全部授权状态" :value="-1"></el-option>
      <el-option label="失败" :value="0"></el-option>
      <el-option label="成功" :value="1"></el-option>
    </el-select>
    <el-select v-model="source" filterable placeholder="来源" class="account-select" style="width: 160px" @change="searchData">
      <el-option label="全部来源" :value="-1"></el-option>
      <el-option label="广告主" value="ADVERTISER"></el-option>
      <el-option label="代理商" value="AGENT"></el-option>
      <el-option label="管家-管理员" value="CUSTOMER_ADMIN"></el-option>
      <el-option label="二级代理商" value="CHILD_AGENT"></el-option>
      <el-option label="管家-操作者" value="CUSTOMER_OPERATOR"></el-option>
      <el-option label="星图账号" value="PLATFORM_ROLE_STAR"></el-option>
    </el-select>
    <el-input placeholder="请输入名称或ID" v-model="search" style="width: 160px" suffix-icon="el-icon-search" @input="inputSearch">
    </el-input>
    <el-button style="margin-left: auto" type="primary" icon="el-icon-refresh" @click="syncAccount" :loading="syncLoading"
      >同步广告账号</el-button
    >
    <el-button style="margin: 0px 24px 0px 16px" type="primary" icon="el-icon-plus" @click="addAdCount">添加广告投放账号</el-button>
  </div>
</template>
<script>
import launchServer from "@/api/account-management";
export default {
  data() {
    return {
      permissionStatus: -1,
      source: -1,
      search: "",
      timer: null,
      syncLoading: false,
    };
  },
  props: {
    platType: Number,
  },
  mounted() {
    // this.getFilterSelectList();
  },
  methods: {
    // getFilterSelectList() {
    //   launchServer.getProducts().then((res) => {
    //     if (res.code === "0000") {
    //       this.productList = res.productList;
    //     }
    //   });
    // },
    getFormatData() {
      let parmas = {};
      this.permissionStatus !== -1 && (parmas.permissionStatus = this.permissionStatus);
      this.source !== -1 && (parmas.source = this.source);
      this.search !== "" && (parmas.search = this.search);

      return parmas;
    },
    searchData() {
      this.$emit("searchData");
    },
    addAdCount() {
      switch (this.platType) {
        case 1:
          window.open(
            "https://open.oceanengine.com/audit/oauth.html?app_id=1707156146679821&state=1707156146679821&scope=[1,%202,%203,%204,%205,%2010000000]&material_auth=1&redirect_uri=https://gateway.wedobest.com.cn:8465/BI" +
              "Serv/bi/callbackToutiao"
          );
          break;
        case 2:
          window.open(
            "https://developers.e.qq.com/oauth/authorize?client_id=1107697793&redirect_uri=https://bi.wedobest.com.cn/BIServ/tencent/auth/callback&state=appid"
          );
          break;
        case 3:
          window.open(
            "https://developers.e.kuaishou.com/tools/authorize?app_id=165896225&scope=%5B%22report_service%22%2C%22ad_query%22%2C%22ad_manage%22%2C%22account_service%22%5D&redirect_uri=https://gateway.wedobest.com.cn:8465/BI" +
              "Serv/bi/callbackKuaishou&state=abcd&oauth_type=advertiser"
          );
          break;
        default:
          break;
      }
    },
    inputSearch() {
      clearTimeout(this.timer);
      this.timer = setTimeout(() => {
        this.searchData();
      }, 500);
    },
    //同步广告账号
    syncAccount() {
      this.syncLoading = true;
      launchServer.uploadAdvertiseInfo().then((res) => {
        if (res.code === "0000") {
          this.syncLoading = false;
          this.$message("同步成功");
          this.$emit("searchData");
        }
      });
    },
  },
};
</script>
<style lang="less" scoped>
.account-filter {
  height: 64px;
  line-height: 64px;
  background-color: #fff;
  margin: 16px;
  display: flex;
  align-items: center;
}
.account-select {
  margin-right: 24px;
  &:nth-child(1) {
    margin-left: 24px;
  }
}
</style>
